export const dialogSizes = {
    XLARGE: 'xl',
    LARGE: 'lg',
    MEDIUM: 'md',
    SMALL: 'sm',
    XSMALL: 'xs'
};